<div class="card card-custom">
  <div class="card-header">
    <div class="card-title">
      <h3 class="card-label">View Mail</h3>
    </div>
  </div>
  <div class="row margin-0 card-body navi-hover" [perfectScrollbar]="{ wheelPropagation: false }">
    <div class="col" *ngIf="attachments && attachments.length > 0 && !hideAttachments">
      <div *ngIf="attachments.length > 1">
        <div id="prevButton">
          <button mat-button color="primary" [disabled]="index === 0" pButton (click)="Previous()">
            Previous
          </button>
        </div>
        <div id="indexCount">{{ index + 1 }} of {{ attachments.length }}</div>
        <div id="nextButton">
          <button
            mat-button
            color="primary"
            [disabled]="index === attachments.length - 1"
            pButton
            (click)="Next()"
          >
            Next
          </button>
        </div>
      </div>
      <ngx-extended-pdf-viewer
        [src]="attachments[index].url"
        [useBrowserLocale]="true"
        [height]="'90vh'"
      ></ngx-extended-pdf-viewer>
    </div>
    <div class="col" *ngIf="item">
      <form class="form" [formGroup]="form">
        <mat-form-field appearance="fill" class="mat-form-field-fluid">
          <mat-label translate="INBOX.FROM">From</mat-label>
          <input matInput formControlName="sender_name" readonly />
        </mat-form-field>
        <mat-form-field appearance="fill" class="mat-form-field-fluid">
          <mat-label translate="INBOX.DATE">Date</mat-label>
          <input type="datetime" matInput formControlName="created" readonly />
        </mat-form-field>
        <mat-form-field appearance="fill" class="mat-form-field-fluid">
          <mat-label translate="INBOX.MESSAGE">Message</mat-label>
          <textarea matInput formControlName="body" rows="20" readonly></textarea>
        </mat-form-field>
      </form>
    </div>
  </div>
  <div class="card-footer">
    <div class="d-flex justify-content-between">
      <div class="mr-2"></div>
      <div>
        <button
          class="mr-2"
          mat-raised-button
          color="primary"
          (click)="reply()"
          translate="INBOX.REPLY"
          [disabled]="typeOfInbox !== 'EMAIL'"
        >
          Reply
        </button>
        <button
          *ngIf="item.status === 'PENDING'"
          class="mr-2"
          mat-raised-button
          color="primary"
          [disabled]="attachments.length == 0"
          (click)="loadWorkflow()"
          translate="INBOX.OPEN_WORKFLOW_DIALOG"
        >
          Open Workflow Dialog
        </button>
        <button mat-button (click)="close()">Cancel</button>
      </div>
    </div>
  </div>
</div>
